<template>
<form @submit.prevent="agregarItem">
  <select
    class="custom-select mb-2"
    v-if="producto.presentacion.length > 0"
    :required="true"
    v-model="producto.presentacion_seleccionada"
    >
    <option value="" selected>Presentación</option>
    <option
      v-for="i in producto.presentacion"
      :key="i.id"
      :value="i"
    >{{ i.nombre }}</option>
  </select>
  <div class="input-group mb-0">
    <input type="number" v-model="producto.cantidad" min="1" class="form-control" placeholder="Cantidad de producto"
    aria-label="Cantidad de producto" :aria-describedby="'button-addon'+producto.id">
    <div class="input-group-append">
      <button
        class="btn btn-outline-primary"
        type="submit"
        :id="'button-addon'+producto.id"
        :disabled="btnAgregar"
      >
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
          v-if="btnAgregar"
        ></span>
        <span class="sr-only" v-if="btnAgregar">Loading...</span>
        <span v-if="!btnAgregar"><i class="fas fa-plus mr-1"></i> Agregar</span>
      </button>
    </div>
  </div>
</form>
</template>

<script>
import axios from 'axios';

export default {
  name: 'BazarForm',
  props: {
    producto: {
      type: Object,
      required: true
    },
    emp: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    btnAgregar: false
  }),
  methods: {
    agregarItem() {
      this.btnAgregar = true;
      let header = JSON.parse(localStorage.getItem(`bazar_${this.emp.dominio}`));

      axios.defaults.headers = {
        Authorization: header.token
      }

      axios
      .post('/app.php/bazar/set_producto', this.producto)
      .then(res => {
        if (res.data.exito) {
          this.$emit('actTotal', this.producto.cantidad, true);
        } else {
          alert(res.data.mensaje);
        }
        this.btnAgregar = false;
      }).catch(e => {
        alert('Carro '+ e);
        this.btnAgregar = false;
      });
    }
  }
}

</script>
